module.exports.getRange = day => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - day);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return [start, end];
};

module.exports.getToday = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    return [start, end];
}
module.exports.getYesterday = () => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    start.setDate(start.getDate() - 1);
    const end = new Date();
    end.setHours(23, 59, 59, 999);
    end.setDate(end.getDate() - 1);
    return [start, end];
}

module.exports.getHours = (hours) => {
    const end = new Date();
    const start = new Date(end.getTime() - hours * 60 * 60 * 1000);
    return [start, end];
}